import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

// Import project images
import project1 from "../../Asset/vit.jpeg";
import project2 from "../../Asset/cmc.jpg";
import project4 from "../../Asset/pwd.jpeg";
import project5 from "../../Asset/corpration project.jpg";


import project3 from "../../Asset/Sri-Lakshmi-Narayani-Golden-Temple.jpg";

const Projects = () => {
  return (
    <div className="max-w-screen-xl mx-auto text-center py-12 px-4 sm:px-6 lg:px-8">
      {/* Heading Section */}
      <h2 className="relative text-center mb-8">
  {/* Background Text */}
  <span className="absolute inset-0 flex items-center justify-center text-5xl sm:text-6xl md:text-5xl lg:text-6xl font-bold text-gray-300 opacity-10 pointer-events-none select-none">
    OUR PROJECTS
  </span>

  {/* Foreground Text */}
  <span className="relative text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#114497]">
    OUR PROJECTS
  </span>
</h2>


      {/* Swiper Slider */}
      <Swiper
        spaceBetween={20}
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        navigation
        breakpoints={{
          320: { slidesPerView: 1 },
          640: { slidesPerView: 1.2 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        }}
        modules={[Navigation, Autoplay]}
        className="w-full"
      >
        {[project1, project2, project3, project4,project5].map((image, index) => (
          <SwiperSlide key={index}>
            <div className="p-2">
              <img
                src={image}
                alt={`Project ${index + 1}`}
                className="w-full h-56 sm:h-72 md:h-56 lg:h-72 object-cover rounded-lg  "
              />
            </div>
          </SwiperSlide>  
        ))}
      </Swiper>
    </div>
  );
};

export default Projects;
